export default __webpack_public_path__ + "static/gen-content-75181553f307dd24cd2a0556148e4d07.png";